<template>
  <div class="inventory">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2> Plant Topping Detail </h2>
        </div>
      </div>
    </div>

    <div class="col-12" v-if=selectedItem>
      <div class="row">
        <div class="col-2">
          <label for="name"> Description: </label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="topping_description"
            ref="description"
            name="name"
            placeholder="name"
            :value="getDescription()"
          />
        </div>

        <div
          v-if="submitted && errors.has('name')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("name") }}
        </div>
      </div>

      <div class="row">
        <div class="col-2">
          <label for="position"> Colour: </label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="topping_colour"
            ref="colour"
            name="colour"
            placeholder="Enter the topping colour"
            :value="getColour()"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-10">
        <!-- $emit calls parent action: "new" -->
        <button id="new" @click="$emit('new')" class="btn btn-plt"> New </button>
        <button v-if=selectedItem id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>

      <div class="col-2" v-if="selectedItem">
        <button id="delete" v-if="selectedItem.active" @click="_delete" class="btn btn-danger">
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ToppingDetail",

  // Props
  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  // DATA
  data: () => ({
    submitted: false,
  }),

  // Computed
  computed: {},

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiSaveTopping", "apiCreateTopping"]),

    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.save();
        }
      });
    },

    _delete() {
      if (this.selectedItem && this.selectedItem.id > 0) {
        this.selectedItem.active = !this.selectedItem.active;
        this.apiSaveTopping(this.selectedItem);
      }
    },

    save() {
      if (this.selectedItem) {
        if (!this.$refs.description.value) {
          alert("please enter a topping description");
          return;
        }
        this.selectedItem.description = this.$refs.description.value;
        this.selectedItem.colour = this.$refs.colour.value;
        this.selectedItem.active = true;

        if (this.selectedItem.id > 0) {
          this.apiSaveTopping(this.selectedItem);
        } else {
          this.apiCreateTopping(this.selectedItem);
        }
        this.$emit("saved");
      }
    },

    getDescription() {
      if (this.selectedItem == null) {
        return "";
      } else {
        return this.selectedItem.description;
      }
    },

    getColour() {
      if (this.selectedItem == null) {
        return "";
      } else {
        return this.selectedItem.colour;
      }
    },
  },

  // Component
  component: {},
};
</script>
